/*───────────────────────────────────────────────────────────────────────────*\
  File        : app/analytics/GoogleAnalytics.tsx
  Description : Client-side Google Analytics 4 bootstrap for application-wide
                page-view tracking.
\*───────────────────────────────────────────────────────────────────────────*/

"use client"

import Script from "next/script"
import { usePathname } from "next/navigation"
import { useEffect } from "react"
import { trackPageView } from "@/src/utils/analytics"

const GA_MEASUREMENT_ID: string = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ?? ""

export default function GoogleAnalytics() {
  const pathname: string = usePathname()

  useEffect((): void => {
    if (!GA_MEASUREMENT_ID) {
      return
    }

    const pagePath: string = `${pathname}${window.location.search}`
    trackPageView(pagePath, document.title)
  }, [pathname])

  if (!GA_MEASUREMENT_ID) {
    return null
  }

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          window.gtag = window.gtag || gtag;
          gtag('js', new Date());
          gtag('config', ${JSON.stringify(GA_MEASUREMENT_ID)}, { send_page_view: false });
        `}
      </Script>
    </>
  )
}

/*──────────────────────────── End of file ────────────────────────────────*/
